import { render } from "./SuperPacmanInstallmentListLegacy.vue?vue&type=template&id=0f899bf0&scoped=true&ts=true"
import script from "./SuperPacmanInstallmentListLegacy.vue?vue&type=script&lang=ts"
export * from "./SuperPacmanInstallmentListLegacy.vue?vue&type=script&lang=ts"

import "./SuperPacmanInstallmentListLegacy.vue?vue&type=style&index=0&id=0f899bf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f899bf0"]])

export default __exports__